import { ReduxService } from 'dashboard-services/services';

import { basicPipelineCreatorActions, saveDialogPipelineCreatorActions } from 'actions/modules/datascience';

export const saveDialogInitialState = {
  isOpen: false,
  groupName: undefined,
  name: undefined,
  tags: [],
  trigger: undefined,

  title: "Save pipeline",
  onClose: () => {},
  markdownId: undefined,
}

export default (state = saveDialogInitialState, action) => {
  switch (action.type) {
    case saveDialogPipelineCreatorActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case saveDialogPipelineCreatorActions.CLEAR_MODAL:
    case basicPipelineCreatorActions.CLEAN_ALL:
      return saveDialogInitialState;
    default:
      return state; 
  }
}